import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the router
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import './assets/main.css';

// Adding icons to the library
library.add(fas, far, fab);

// Create the Vue app
const app = createApp(App);

// Register FontAwesomeIcon component globally
app.component('FontAwesomeIcon', FontAwesomeIcon);

// Use the router
app.use(router);

// Mount the app to the DOM
app.mount('#app');